/* eslint-disable eqeqeq */
/* eslint-disable use-isnan */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import parse from 'html-react-parser';
import { saveItemToStore } from '../../../utils/sessionStorage';
import { updateUrl } from '../../common/Tagging/index';
import { isLoggedIn, getSession, pdcAEMCheck, isPreorder, renderHTML } from '../../common/Helpers/index';
import { store } from '../../../configureStore';

// import { redirectToHomePage } from '../../common/Helpers/commonLog';

export const paymentCommonMethod = (thisVal) => {
  document.title = 'Verizon Wireless';
  saveItemToStore('ccAttempts', 0);
  updateUrl();
  const btn = document.getElementById('refSecDep');
  if (btn) {
    btn.addEventListener('click', this.modalrefundableOpen);
  }
  thisVal.setState({ modalOpened: false });
  const data = {
    pageName: 'payment',
  };
  if (!isLoggedIn() && pdcAEMCheck()) {
    thisVal.props.updatePdc(data);
  }
  thisVal.update();
  if (!getSession('paypalAuthFailed')) {
    store.dispatch({ type: 'CEF_PAYMENT_INFO_ERROR', response: false, errorMessage: null });
  }
};
export const notificationProps = (PropsVal, showCreditMsg, updateTaggingInfoMessage, notifyMessage, notificationHead) => {
  let fwaSecurityDeposit = PropsVal.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo?.fwaSecurityDepositAmount;
  fwaSecurityDeposit = fwaSecurityDeposit !== undefined && fwaSecurityDeposit !== null && fwaSecurityDeposit !== '' ? fwaSecurityDeposit : 0;

  let { notificationTitle = '' } = PropsVal;
  const flowType = getSession('FlowType');
  notificationTitle =notificationTitle.replace('XXXX', flowType);
  const isInvalidZipcodeError = PropsVal.isInvalidZipcodeError || false;
  const securityDepositNotifText = PropsVal.securityDepositNotificationMobile;
  const securityDepTitle = securityDepositNotifText ? parse(securityDepositNotifText?.split('<br>')[0]) : '';
  let securityDepSubtitle = securityDepositNotifText?.split('<br>')[1];
  if (isPreorder()) {
    securityDepSubtitle = securityDepSubtitle?.replace('due today', 'due at shipment');
  }
  securityDepSubtitle = securityDepSubtitle ? parse(securityDepSubtitle?.replace('xx.xx', fwaSecurityDeposit)) : '';

  const maxValue = PropsVal.paymentInfoState && PropsVal.paymentInfoState.maxAttemptError;
  const notificationProp = {
    renderIf: false,
    title: '',
    type: '',
    subtitle: '',
    serviceInfo: '',
  };
  if (PropsVal.paymentError) {
    notificationProp.renderIf = true;
    notificationProp.title = renderHTML(PropsVal.paymentNtfyMsg || 'Looks like something went wrong. Please try again later.');
    notificationProp.type = 'warning';
  } else if (PropsVal.showError || PropsVal.isPostPaymentPaypalError || PropsVal.showPaymentApiError) {
    notificationProp.renderIf = PropsVal.showError || PropsVal.isPostPaymentPaypalError || PropsVal.showPaymentApiError;
    notificationProp.title = 'Looks like something went wrong. Please try again later.';
    if (PropsVal.isPostPaymentPaypalError) {
      if (PropsVal.paymentResponseError?.id === '3604') {
        notificationProp.title = notifyMessage;
      } else if (PropsVal.paymentResponseError?.id === '4006') {
        notificationProp.title = notificationHead;
      } else {
        notificationProp.title = PropsVal.paymentResponseError?.message
          ? PropsVal.paymentResponseError.message
          : 'Looks like something went wrong. Please try again later.';
      }
    } else if (maxValue) {
      notificationProp.title =
        "We're sorry, you've exceeded the maximum amount of attempts. Please visit your nearest Verizon store to process your order.";
    }
    notificationProp.type = 'warning';
    notificationProp.subtitle = '';
    notificationProp.serviceInfo = PropsVal?.paymentServiceInfo;
  } else if (showCreditMsg && !PropsVal.showError && !PropsVal.showPaymentApiError) {
    notificationProp.renderIf = showCreditMsg && !PropsVal.showError && !PropsVal.showPaymentApiError;
    notificationProp.title = notificationTitle;
    notificationProp.type = 'success';
    notificationProp.subtitle = '';
  } else if (isInvalidZipcodeError) {
    notificationProp.title = 'Please enter a valid zipcode';
    notificationProp.renderIf = PropsVal.isInvalidZipcodeError;
    notificationProp.serviceInfo = PropsVal.serviceinfo;
  } else if (!isLoggedIn() && fwaSecurityDeposit > 0) {
    notificationProp.renderIf = !isLoggedIn() && fwaSecurityDeposit > 0;
    notificationProp.title = securityDepTitle;
    notificationProp.type = 'info';
    notificationProp.subtitle = securityDepSubtitle;
    updateTaggingInfoMessage(securityDepTitle);
  }
  return notificationProp;
};
